import { TFunction } from 'i18next'
import { StringSchema, mixed } from 'yup'

import { dniValidate, documentType } from '@/Shared/domain'
import {
  nonEmptyStringSchema,
  stringSchema,
} from '@/Shared/ui/form'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const documentTypeSchema = (
  t: TFunction<'translation', undefined>,
  required = true,
) => {
  const validOptions = [
    documentType.DniNie,
    documentType.Passport,
  ]

  return mixed()
    .test(
      'required-check',
      t(formTranslation.errors.fieldRequired),
      function(value) {
        // Si es requerido y es string vacío, null o undefined, fallar
        if (required && (value === '' || value === null || value === undefined)) {
          return false;
        }
        return true;
      }
    )
    .test(
      'valid-option',
      t(formTranslation.errors.fieldRequired),
      function(value) {
        // Si no es requerido y es vacío, pasar
        if (!required && (value === '' || value === null || value === undefined)) {
          return true;
        }
        
        // Si es string, convertir a número y validar
        if (typeof value === 'string' && value !== '') {
          const parsed = parseInt(value, 10);
          if (isNaN(parsed)) {
            return false;
          }
          return validOptions.includes(parsed);
        }
        
        // Si es número, validar directamente
        if (typeof value === 'number') {
          return validOptions.includes(value);
        }
        
        // Cualquier otro caso
        return !required;
      }
    )
    .transform((value) => {
      // Solo transformar si no es string vacío
      if (value === '' || value === null || value === undefined) {
        return undefined;
      }
      if (typeof value === 'string') {
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? undefined : parsed;
      }
      return value;
    });
}

export const documentNumberSchema = (
  t: TFunction<'translation', undefined>,
  required = true,
  depdendantField?: string,
): StringSchema<string | undefined> => {
  const schema = required ? nonEmptyStringSchema(t) : stringSchema(t)

  return schema
    .test(
      'must-comply-format',
      t(formTranslation.errors.invalidFormat),
      (value, context) => {
        if (
          value &&
          context.parent[depdendantField ?? 'document_type'] === documentType.DniNie
        ) {
          return dniValidate(value)
        }

        return true
      },
    )
    .max(14, t(formTranslation.errors.maxChars, { value: 14 }))
}
